import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: 'Anuluj',
  save: 'Zatwierdź',
});
